import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPage, IPageWithAction } from "src/models/Maintenance/Page.models";

interface PageState {
  pages: IPage[];
  pagesWithActions: IPageWithAction[];
  pageToEdit: IPage | null;
}

const initialState: PageState = {
  pages: [],
  pagesWithActions: [],
  pageToEdit: null,
};

const pageSlice = createSlice({
  name: "Page",
  initialState,
  reducers: {
    setPageList: (state, action: PayloadAction<IPage[]>) => {
      state.pages = action.payload;
    },
    concatListPage: (state: PageState, action: PayloadAction<IPage[]>) => {
      state.pages = [...state.pages.concat(action.payload)];
    },
    setPageListWithActions: (
      state,
      action: PayloadAction<IPageWithAction[]>
    ) => {
      state.pagesWithActions = action.payload;
    },
    setPageToEdit: (state, action: PayloadAction<IPage | null>) => {
      state.pageToEdit = action.payload;
    },
    addPage: (state, action: PayloadAction<IPage>) => {
      state.pages.push(action.payload);
    },
    updatePage: (state, action: PayloadAction<IPage>) => {
      let itemIndex = state.pages.findIndex(
        item => item.pageId === action.payload.pageId
      );
      if (itemIndex !== -1) state.pages[itemIndex] = action.payload;
    },
    deletePage: (state, action: PayloadAction<number>) => {
      const newArray = state.pages.filter(
        item => item.pageId !== action.payload
      );
      state.pages = newArray;
    },
  },
});

export const {
  setPageList,
  concatListPage,
  setPageListWithActions,
  setPageToEdit,
  addPage,
  updatePage,
  deletePage,
} = pageSlice.actions;

export default pageSlice.reducer;
